import $  from 'jquery';
import Reflux from 'reflux';
import Tracking from 'medscape/tracking';
//import Actions from './slide-actions';

export default class SlideStore extends Reflux.Store
{
    constructor(props)
    {
        super();
        this.state = this.getInitialState();
        this.props = props;
        this.listenables = props.SlideActions;
    }
    getInitialState(){
        return {
          showNotes: false,
          showLinks: false
        }
    }

    afterChange(index){

    }
    beforeChange(currIndex,nextIndex){
        this.setState({
            showLinks: false,
            showNotes: false
        })
    }
    onToggleNotes(index,flag = !this.state.showNotes){
        if(this.props.index==index){
          this.setState({
            showLinks: false,
            showNotes: flag
          })
        }
    }
    onToggleLinks(flag = !this.state.showLinks){
        this.setState({
            showNotes: false,
            showLinks: flag
        })
    }
}




// WEBPACK FOOTER //
// ./src/app/carousel/slide-store.js